import { supabase } from "@/lib/supabase";
import type { Database } from "@/types/database";

export type Notification = Database["public"]["Tables"]["notificacoes"]["Row"];

export const notificationsService = {
  async list(limit = 8): Promise<Notification[]> {
    const { data, error } = await supabase
      .from("notificacoes")
      .select("*")
      .order("criada_em", { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data ?? [];
  },

  async markAsRead(id: string) {
    const { error } = await supabase
      .from("notificacoes")
      .update({ lida: true, lida_em: new Date().toISOString() })
      .eq("id", id);
    if (error) throw error;
  },

  async markAllAsRead() {
    const { error } = await supabase
      .from("notificacoes")
      .update({ lida: true, lida_em: new Date().toISOString() })
      .eq("lida", false);
    if (error) throw error;
  },
};
